import stringReplacer from './string';
export default function (_, mods, value) {
    return stringReplacer('s', mods, String.fromCharCode(Math.floor(value)));
}
